import { Button, Checkbox, Form, Modal, Spin } from "antd";
import React from "react";
import moment from "moment";
import configssAdmin from "../../../../apis/admin/config.service";
import notificationHandler from "../../../atoms/Notification";
import {
  ExclamationCircleOutlined,
  LoadingOutlined,
  ReloadOutlined,
  SaveOutlined,
} from "@ant-design/icons";
import Title from "antd/es/typography/Title";
import MultipleDatePicker from "../../../molecules/MultipleDatePicker";
import "./order-time.scss";

type Props = {};

const ListOderTime = (props: Props) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = React.useState(false);
  const [modal, contextHolder] = Modal.useModal();

  // const [weekendDay, setWeeendDay] = React.useState<any>([]);
  // const [defaultDateList, setDefaultDateList] = React.useState<any>([]);
  // const [dateList, setDateList] = React.useState<any>([]);
  // const [checked, setChecked] = React.useState(false);
  // const [checkedHoliday, setCheckedHoliday] = React.useState(false);
  // const [dateListMore, setDateListMore] = React.useState<any>([]);
  // const [defaultDateListMore, setDefaultDateListMore] = React.useState<any>([]);
  // const [checkedMore, setCheckedMore] = React.useState(false);

  const [dateSelected, setDateSelected] = React.useState<any>([]);
  const [dateNotSelected, setDateNotSelected] = React.useState<any>([]);
  
  const [isAutoAddWeekend, setIsAutoAddWeekend] = React.useState(false);
  

  React.useEffect(() => {
    setLoading(true);
    configssAdmin
      .getDataHolydays()
      .then((res: any) => {
        if (res?.data?.data?.payload.length > 0) {
          let data = res?.data?.data?.payload;

          let holiday = data.map((item: any) =>
            new Date(item.date).getTime()
          );

          console.log(holiday);
          handleClassifyDate(holiday);
        }
      })
      .catch((err) => {
        notificationHandler("error", err.response.data.data.msg_content);
      })
      .finally(() => setLoading(false));
  }, []);

  const getWeekendDays = () => {
    const firstDayOfMonth = moment().startOf("month");
    const lastDayOfMonth = moment().endOf("month");
    const allDaysInMonth = [];
    const currentDay = firstDayOfMonth.clone();
    while (currentDay.isSameOrBefore(lastDayOfMonth)) {
      allDaysInMonth.push(currentDay.clone());
      currentDay.add(1, "day");
    }
    const weekendsInMonth = allDaysInMonth
      .filter((date) => date.day() === 0 || date.day() === 6)
      .map((date: any) => new Date(date).getTime());

    return weekendsInMonth;
  };

  const handleClassifyDate = (data: any) => {
    let weekend = getWeekendDays();

    const holidaySet = new Set(data);
    const isSubList = weekend.every((item) => holidaySet.has(item));
    
    form.setFieldValue('mulitiple', data)
    setDateSelected(data);
    setIsAutoAddWeekend(isSubList);
  }

  const confirm = (values: any) => {
    modal.confirm({
      title: "Bạn có chắc chắn muốn thay đổi dữ liệu?",
      icon: <ExclamationCircleOutlined />,
      okText: "Đồng ý",
      cancelText: "Hủy",
      okType: "danger",
      onOk: () => confirmButtonUpdate(values),
    });
  };

  const antIcon = (
    <LoadingOutlined style={{ fontSize: 70, position: "fixed" }} spin />
  );

  const confirmButtonUpdate = async (values: any) => {
    try {
      // await updateWhiteDays([])
      await updateHolidays(dateSelected);
    } catch (err: any) {
      notificationHandler("error", err.response?.data?.data?.payload);
    }
  }

  const updateWhiteDays = async (data: any) => {
    const res: any = await configssAdmin.updateDataWhiteDay(data);
    const hasOrderInWhileDay = res?.data?.data?.msg_code == "200";

    if (hasOrderInWhileDay) {
      modal.confirm({
        title: res?.data?.data?.payload,
        icon: <ExclamationCircleOutlined />,
        okText: "Đồng ý",
        cancelText: "Hủy",
        okType: "danger",
        onOk: () => confirmPopupWhileDay([]),
      });
    } else {
      confirmPopupWhileDay([]);
    }
  }

  const confirmPopupWhileDay = async (data: any) => {
    try {
      setLoading(true);
      await configssAdmin.createDataWhiteDay(data);
      setLoading(false);
    } catch (err: any) {
      setLoading(false);
      notificationHandler("error", err.response?.data?.data?.payload);
    }
  };

  const updateHolidays = async (data: any) => {
    try {
      const req = data.map((item: any) => {
        return {
          date: moment(item).format("YYYY-MM-DD"),
        };
      });
      const res: any = await configssAdmin.updateDataHolydays(req);
      const hasOrderInHoliday = res?.data?.data?.msg_code == "200";

      if (hasOrderInHoliday) {
        modal.confirm({
          title: res?.data?.data?.payload,
          icon: <ExclamationCircleOutlined />,
          okText: "Đồng ý",
          cancelText: "Hủy",
          okType: "danger",
          onOk: () => confirmPopupHoliday(data),
        });
      } else {
        confirmPopupHoliday(data);
      }

    } catch (err: any) {
      notificationHandler("error", err.response?.data?.data?.payload);
    }
  }

  const confirmPopupHoliday = async (data: any) => {
    try {
      setLoading(true);
      const req = data.map((item: any) => {
        return {
          date: moment(item).format("YYYY-MM-DD"),
        };
      });

      const res: any = await configssAdmin.createDataHolydays(req);
      const isSuccess = res?.data?.data?.msg_code == "200";

      if (isSuccess) {
        notificationHandler("success", res?.data?.data?.payload);
      }

      setLoading(false);
    } catch (err: any) {
      setLoading(false);
      notificationHandler("error", err.response?.data?.data?.payload);
    }
  };

  const handleChangeDatePicker = (data: any, time: any) => {
    const hasContrain = dateNotSelected.includes(time);

    let notSelected = [...dateNotSelected]
    notSelected.push(time);

    if (hasContrain) {
      notSelected = [...dateNotSelected].filter((item: any) => item !== time);
    }
    

    console.log(dateNotSelected)
    console.log(time)
    console.log(notSelected)

    setDateNotSelected(notSelected);
    handleClassifyDate(data);
  }

  const handleClearDatePicker = () => {
    handleClassifyDate([]);
  }


  const handleCheckBoxAutoAddAllWeekend = () => {
    let selected = dateSelected;
    let notSelected = dateNotSelected
    if (isAutoAddWeekend) {
      selected = dateSelected.filter((item: any) => !dateNotSelected.includes(item))
      notSelected = [];
    } else {
      let weekends = getWeekendDays();

      notSelected = weekends.filter((item: any) => !dateSelected.includes(item))
      selected = dateSelected.concat(notSelected);
    }

    handleClassifyDate(selected)
    setDateNotSelected(notSelected);
  };

  // React.useEffect(() => {
  //   setLoading(true);
  //   configssAdmin
  //     .getDataHolydays()
  //     .then((res: any) => {
  //       if (res?.data?.data?.payload.length > 0) {
  //         let holiday = res?.data?.data?.payload.map((item: any) =>
  //           moment(item.date).format("DD/MM/YYYY")
  //         );
  //         let weekE = getWeekendDays().map((item: any) =>
  //           moment(item).format("DD/MM/YYYY")
  //         );
  //         if (holiday.find((item: any) => weekE.includes(item))) {
  //           setChecked(true);
  //         }
  //         setDefaultDateList(
  //           res?.data?.data?.payload.map((item: any) =>
  //             new Date(item.date).getTime()
  //           )
  //         );
  //       }
  //     })
  //     .catch((err) => {
  //       notificationHandler("error", err.response.data.data.msg_content);
  //     })
  //     .finally(() => setLoading(false));
  // }, []);
  // React.useEffect(() => {
  //   setLoading(true);
  //   configssAdmin
  //     .getDataWhiteDay()
  //     .then((res: any) => {
  //       if (res?.data?.data?.payload.length > 0) {
  //         let holiday = res?.data?.data?.payload.map((item: any) =>
  //           moment(item.date).format("DD/MM/YYYY")
  //         );
  //         let weekE = getWeekendDays().map((item: any) =>
  //           moment(item).format("DD/MM/YYYY")
  //         );
  //         if (holiday.find((item: any) => weekE.includes(item))) {
  //           setCheckedMore(true);
  //         }
  //         setDefaultDateListMore(
  //           res?.data?.data?.payload.map((item: any) =>
  //             new Date(item.date).getTime()
  //           )
  //         );
  //       }
  //     })
  //     .catch((err) => {
  //       notificationHandler("error", err.response.data.data.msg_content);
  //     })
  //     .finally(() => setLoading(false));
  // }, []);


  // const onFinish = (values: any) => {
  //   const holydays = dateList
  //     .filter(function (item: string, pos: number) {
  //       return dateList.indexOf(item) == pos;
  //     })
  //     .map((item: any) => {
  //       return {
  //         date: moment(item).format("YYYY-MM-DD"),
  //       };
  //     });
  //   const holydaysMore = dateListMore
  //     .filter(function (item: string, pos: number) {
  //       return dateListMore.indexOf(item) == pos;
  //     })
  //     .map((item: any) => {
  //       return {
  //         date: moment(item).format("YYYY-MM-DD"),
  //       };
  //     });

  //   updateWhiteDay(holydays, values, holydaysMore);
  //   // updateHolyDay(holydays, values, holydaysMore)
  // };

  // const getWeekendDays = () => {
  //   const firstDayOfMonth = moment().startOf("month");
  //   const lastDayOfMonth = moment().endOf("month");
  //   const allDaysInMonth = [];
  //   const currentDay = firstDayOfMonth.clone();
  //   while (currentDay.isSameOrBefore(lastDayOfMonth)) {
  //     allDaysInMonth.push(currentDay.clone());
  //     currentDay.add(1, "day");
  //   }
  //   const weekendsInMonth = allDaysInMonth
  //     .filter((date) => date.day() === 0 || date.day() === 6)
  //     .map((date: any) => new Date(date).getTime());

  //   return weekendsInMonth;
  // };

  // const handleAllHoliday = (check: Boolean) => {
  //   setChecked(!checked);
  //   let weekends = getWeekendDays().map((item: any) =>
  //     moment(item).format("DD/MM/YYYY")
  //   );
  //   let defDate = defaultDateList.map((item: any) =>
  //     moment(item).format("DD/MM/YYYY")
  //   );

  //   if (check) {
  //     setWeeendDay(getWeekendDays());
  //   } else {
  //     if (JSON.stringify(weekends) === JSON.stringify(defDate)) {
  //       setDefaultDateList([]);
  //     } else {
  //       setWeeendDay(
  //         defDate
  //           .filter((item: any) => !weekends.includes(item))
  //           .map((item: any) => new Date(item).getTime())
  //       );
  //     }
  //   }
  // };

  // const handleSelectedDate = (date: any) => {
  //   console.log("handleSelectedDate", date);
  //   setDateSelected(date);
  // };
  // const CreateHolydays = async (holiday: any, date: any) => {
  //   setLoading(true);
  //   try {
  //     const res: any = await configssAdmin.createDataHolydays(holiday);
  //     if (res?.data?.data?.msg_code == "200") {
  //       notificationHandler("success", res?.data?.data?.payload);
  //     }
  //     setLoading(false);
  //   } catch (e) {}
  // };
  // const updateHolyDay = (data: any, date: any, dataMore: any) => {
  //   configssAdmin
  //     .updateDataHolydays(data)
  //     .then((res: any) => {
  //       if (res?.data?.data?.msg_code == "200") {
  //         modal.confirm({
  //           title: res?.data?.data?.payload,
  //           icon: <ExclamationCircleOutlined />,
  //           okText: "Đồng ý",
  //           cancelText: "Hủy",
  //           okType: "danger",
  //           onOk: () => CreateHolydays(data, date),
  //         });
  //       } else {
  //         CreateHolydays(data, date);
  //       }
  //     })
  //     .catch((err) => {
  //       notificationHandler("error", err.response?.data?.data?.payload);
  //     });
  // };

  // const onClear = () => {
  //   setWeeendDay([]);
  //   if (checked) {
  //     setChecked(false);
  //   }
  // };

  // const handleChange = (list: any) => {
  //   setDateList(list);
  //   const weekends = getWeekendDays().map((item: any) =>
  //     moment(item).format("DD/MM/YYYY")
  //   );
  //   const selectedDates = list.map((item: any) =>
  //     moment(item).format("DD/MM/YYYY")
  //   );

  //   const isCheckAll = weekends.every((day: any) =>
  //     selectedDates.includes(day)
  //   );
  //   setCheckedHoliday(isCheckAll); // Chỉ ảnh hưởng đến ngày lễ
  // };

  // const CreateWhiteDay = async (holiday: any, date: any, whiteday: any) => {
  //   setLoading(true);
  //   try {
  //     const res: any = await configssAdmin.createDataWhiteDay(whiteday);
  //     if (res?.data?.data?.msg_code == "200") {
  //       updateHolyDay(holiday, date, whiteday);

  //       // CreateHolydays(holiday, date)
  //     } else {
  //       updateHolyDay(holiday, date, whiteday);

  //       // CreateHolydays(holiday, date)
  //     }
  //     setLoading(false);
  //   } catch (err: any) {
  //     setLoading(false);
  //     notificationHandler("error", err.response?.data?.data?.payload);
  //   }
  // };

  // const updateWhiteDay = async (data: any, date: any, dataMore: any) => {
  //   setLoading(true);
  //   configssAdmin
  //     .updateDataWhiteDay(dataMore)
  //     .then((res: any) => {
  //       if (res?.data?.data?.msg_code == "200") {
  //         modal.confirm({
  //           title: res?.data?.data?.payload,
  //           icon: <ExclamationCircleOutlined />,
  //           okText: "Đồng ý",
  //           cancelText: "Hủy",
  //           okType: "danger",
  //           onOk: () => CreateWhiteDay(data, date, dataMore),
  //         });
  //       } else {
  //         CreateWhiteDay(data, date, dataMore);
  //       }
  //       setLoading(false);
  //     })
  //     .catch((err) => {
  //       notificationHandler("error", err.response?.data?.data?.payload);
  //     });
  // };
  return (
    <div id="order-time">
      <Spin indicator={antIcon} spinning={loading} />
      <Form
        form={form}
        name="change menu"
        layout={"vertical"}
        style={{ maxWidth: 600 }}
        onFinish={confirm}
        autoComplete="off"
        className="p-[10px]"
      >
        <Title className="!text-[20px]">
          Thay đổi cấu hình thời gian đặt cơm
        </Title>
        <Form.Item name="mulitiple" label="Chọn ngày lễ">
          <MultipleDatePicker
            onChange={handleChangeDatePicker}
            onClear={handleClearDatePicker}
            value={dateSelected}
          />
        </Form.Item>
        <Form.Item name="">
          <Checkbox
            checked={isAutoAddWeekend}
            onChange={(e) => {
              // handleAllHoliday(e.target.checked)
              handleCheckBoxAutoAddAllWeekend();
            }}
          >
            Chọn tất cả các ngày thứ 7 chủ nhật trong tháng hiện tại
          </Checkbox>
        </Form.Item>
        {/* <Form.Item name="mulitiple1" label="Chọn ngày cho phép đặt cơm">
          <MultipleDatePicker
            checked={checkedMore}
            onChange={handleChangeMore}
            onClear={onClearMore}
            selectedWeekend={weekendDayMore.concat(defaultDateListMore)}
            listWeekend={getWeekendDays}
            defaultDateList={defaultDateListMore}
            submit={handleSelectedDateMore}
            ísClass="whitelist"
          />
        </Form.Item>
        <Form.Item name="">
          <Checkbox
            checked={checkedMore}
            onChange={(e) => handleAllWhiteList(e.target.checked)}
          >
            Chọn tất cả các ngày thứ 7 chủ nhật trong tháng hiện tại
          </Checkbox>
        </Form.Item> */}
        <div className="flex">
          <Button
            htmlType="submit"
            type="primary"
            className="mt-4 bg-[#1890ff] hover:bg-white hover:text-[#1890ff]"
          >
            <SaveOutlined /> Cập nhật
          </Button>
          <Button
            htmlType="reset"
            onClick={() => {
              setDateSelected([])
              setIsAutoAddWeekend(false)
            }}
            className="mt-4 text-[##ff4d4f] ml-4  bg-[#ff4d4f] text-white"
            danger
          >
            <ReloadOutlined /> Đặt lại
          </Button>
        </div>
        {contextHolder}
      </Form>
    </div>
  );
};

export default ListOderTime;
